import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { t } from 'i18next';
import ServiceItem from '../Services/ServiceItem';
import i18n from '../../i18n';

const RandomService = () => { 
  const services = t("services.service", { returnObjects: true });
  const limitedServices = services.slice(0, 2);
 
  return (
    <section className="relative py-12 md:py-16 px-4 md:px-6 bg-gradient-to-b from-gray-50 via-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <header className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl mb-2 md:text-4xl lg:text-5xl font-extrabold text-primeColor tracking-tight relative inline-block">
            {t("services.title")}
            <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-1 rounded-full bg-secondColor"></span>
          </h2>
          <p className=" text-gray-600 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            {t("services.description") || "Discover our comprehensive range of medical services"}
          </p>
        </header>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10">
          {limitedServices.map((service, index) => (
            <div 
              key={service.id || index}
              className="animate-fadeIn"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <ServiceItem service={service} />
            </div>
          ))}
        </div>

        {/* View All Link */}
        <div className="flex justify-center">
          <Link
            to="/services" 
            className="group no-underline inline-flex items-center gap-2 text-primeColor-500 hover:!bg-primeColor-500 hover:text-white transition-all duration-300 font-semibold text-base md:text-lg px-6 py-3 rounded-full border border-secondColor/40 hover:border-primeColor bg-white/70 hover:bg-white shadow-sm hover:shadow-md"
          >
            <span>{t("services.viewAll") || t("services.title")}</span>
            {i18n.language === "ar" ? (
              <FaArrowLeft className="transition-transform duration-300 group-hover:-translate-x-1" size={18} />
            ) : (
              <FaArrowRight className="transition-transform duration-300 group-hover:translate-x-1" size={18} />
            )}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default RandomService;



